<template>
  <div>
    <page-nav-bar
      v-if="u && !loading"
      :is-sticky="true"
      :back-button="true"
      :has-actions="false">
      <template slot="breadcrumb">
        <h1>
          <span class="page-header-breadcrumb-item">
            Édition de l'utilisateur
          </span>
        </h1>
        <div class="page-header-breadcrumb-separator"></div>
        <div
          class="page-header-breadcrumb-item"
          v-if="u && u.last_name && u.first_name && !isMe">
          <span class="has-text-weight-normal has-text-grey-dark"><span class="is-uppercase">{{ u.last_name }}</span> {{ u.first_name }}</span>
        </div>
      </template>
    </page-nav-bar>
    <page-content
      :has-left-col-small="false"
      :has-left-col-small-size-fixed="false"
      :has-sticky-col-left="false"
      :set-main-col-class="(!isMe) ? 'is-12 is-9-widescreen is-8-fullhd' : ''">
      <div class="has-background-white is-border">
        <user-form
          @submit="updateUser"
          :source-loading="loading"></user-form>
      </div>
    </page-content>
  </div>
</template>

<script>
import { User } from '@/mixins'

export default {
  name: 'UserEdit',
  components: {
    UserForm: () => import('@/components/users/UserForm')
  },
  mixins: [User]
}
</script>
